import {
  MDBSelect
} from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMisc } from "../../../apiclients/streamsapi_bridge";

const UserSpamSettings = ({
  setValue,
  watch,
  isstreamsReq
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [spamBlocking, setspamBlocking] = useState([]);


  useEffect(() => {
    getSpamBlockList();
  }, []);

  async function getSpamBlockList() {
      let updates = {};
      console.log(sessionStorage.getItem("admin_session"));
      updates = {
        misc: ["spam_blocking"],
      };
  
      const response = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        updates
      );
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const basicInfo = await response.json();
      if (!basicInfo) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
  
      const spamBlockingOptions = basicInfo.misc.spam_blocking ?? {};
      const spamBlockingList = Object.entries(spamBlockingOptions).map(
        ([value, text]) => ({
          value: parseInt(value),
          text,
        })
      );
      setspamBlocking(spamBlockingList ?? []);
    }


  return (
    <>
      <div className="general-settings">
        {t("Spam_settings")}
      </div>
      <div className="ps-0">
        {/* Arrangement of order according to Jerome's Enhancements suggested changes */}
        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("Spam_settings")}
            <br />
            <span className="phrecording text-secondary">
              {t("Spam_settings_Text")}
            </span>
          </div>
          <div
            {...(isstreamsReq
              ? {
                title: "User does not have permission to edit",
                className: "disabled-form cursor-notAllowed",
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                },
              }
              : {})}
          >
            <div className="phoneselect">
              <MDBSelect
                className="w-100"
                name="San Jose"
                value={parseInt(watch("allow_user_set_spam"))}
                data={spamBlocking}
                onChange={(e) => {
                  if (e && e.value) {
                    setValue("allow_user_set_spam", parseInt(e.value), {
                      shouldDirty: true,
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default UserSpamSettings;
